import * as _fs2 from "fs";

var _fs = "default" in _fs2 ? _fs2.default : _fs2;

import * as _arrayUnion2 from "array-union";

var _arrayUnion = "default" in _arrayUnion2 ? _arrayUnion2.default : _arrayUnion2;

import * as _merge2 from "merge2";

var _merge = "default" in _merge2 ? _merge2.default : _merge2;

import * as _fastGlob2 from "fast-glob";

var _fastGlob = "default" in _fastGlob2 ? _fastGlob2.default : _fastGlob2;

import * as _dirGlob2 from "dir-glob";

var _dirGlob = "default" in _dirGlob2 ? _dirGlob2.default : _dirGlob2;

import _gitignore from "./gitignore";
import _streamUtils from "./stream-utils";
var exports = {};
const fs = _fs;
const arrayUnion = _arrayUnion;
const merge2 = _merge;
const fastGlob = _fastGlob;
const dirGlob = _dirGlob;
const gitignore = _gitignore;
const {
  FilterStream,
  UniqueStream
} = _streamUtils;

const DEFAULT_FILTER = () => false;

const isNegative = pattern => pattern[0] === "!";

const assertPatternsInput = patterns => {
  if (!patterns.every(pattern => typeof pattern === "string")) {
    throw new TypeError("Patterns must be a string or an array of strings");
  }
};

const checkCwdOption = (options = {}) => {
  if (!options.cwd) {
    return;
  }

  let stat;

  try {
    stat = fs.statSync(options.cwd);
  } catch {
    return;
  }

  if (!stat.isDirectory()) {
    throw new Error("The `cwd` option must be a path to a directory");
  }
};

const getPathString = p => p.stats instanceof fs.Stats ? p.path : p;

const generateGlobTasks = (patterns, taskOptions) => {
  patterns = arrayUnion([].concat(patterns));
  assertPatternsInput(patterns);
  checkCwdOption(taskOptions);
  const globTasks = [];
  taskOptions = {
    ignore: [],
    expandDirectories: true,
    ...taskOptions
  };

  for (const [index, pattern] of patterns.entries()) {
    if (isNegative(pattern)) {
      continue;
    }

    const ignore = patterns.slice(index).filter(pattern => isNegative(pattern)).map(pattern => pattern.slice(1));
    const options = { ...taskOptions,
      ignore: taskOptions.ignore.concat(ignore)
    };
    globTasks.push({
      pattern,
      options
    });
  }

  return globTasks;
};

const globDirs = (task, fn) => {
  let options = {};

  if (task.options.cwd) {
    options.cwd = task.options.cwd;
  }

  if (Array.isArray(task.options.expandDirectories)) {
    options = { ...options,
      files: task.options.expandDirectories
    };
  } else if (typeof task.options.expandDirectories === "object") {
    options = { ...options,
      ...task.options.expandDirectories
    };
  }

  return fn(task.pattern, options);
};

const getPattern = (task, fn) => task.options.expandDirectories ? globDirs(task, fn) : [task.pattern];

const getFilterSync = options => {
  return options && options.gitignore ? gitignore.sync({
    cwd: options.cwd,
    ignore: options.ignore
  }) : DEFAULT_FILTER;
};

const globToTask = task => glob => {
  const {
    options
  } = task;

  if (options.ignore && Array.isArray(options.ignore) && options.expandDirectories) {
    options.ignore = dirGlob.sync(options.ignore);
  }

  return {
    pattern: glob,
    options
  };
};

exports = async (patterns, options) => {
  const globTasks = generateGlobTasks(patterns, options);

  const getFilter = async () => {
    return options && options.gitignore ? gitignore({
      cwd: options.cwd,
      ignore: options.ignore
    }) : DEFAULT_FILTER;
  };

  const getTasks = async () => {
    const tasks = await Promise.all(globTasks.map(async task => {
      const globs = await getPattern(task, dirGlob);
      return Promise.all(globs.map(globToTask(task)));
    }));
    return arrayUnion(...tasks);
  };

  const [filter, tasks] = await Promise.all([getFilter(), getTasks()]);
  const paths = await Promise.all(tasks.map(task => fastGlob(task.pattern, task.options)));
  return arrayUnion(...paths).filter(path_ => !filter(getPathString(path_)));
};

exports.sync = (patterns, options) => {
  const globTasks = generateGlobTasks(patterns, options);
  const tasks = [];

  for (const task of globTasks) {
    const newTask = getPattern(task, dirGlob.sync).map(globToTask(task));
    tasks.push(...newTask);
  }

  const filter = getFilterSync(options);
  let matches = [];

  for (const task of tasks) {
    matches = arrayUnion(matches, fastGlob.sync(task.pattern, task.options));
  }

  return matches.filter(path_ => !filter(path_));
};

exports.stream = (patterns, options) => {
  const globTasks = generateGlobTasks(patterns, options);
  const tasks = [];

  for (const task of globTasks) {
    const newTask = getPattern(task, dirGlob.sync).map(globToTask(task));
    tasks.push(...newTask);
  }

  const filter = getFilterSync(options);
  const filterStream = new FilterStream(p => !filter(p));
  const uniqueStream = new UniqueStream();
  return merge2(tasks.map(task => fastGlob.stream(task.pattern, task.options))).pipe(filterStream).pipe(uniqueStream);
};

exports.generateGlobTasks = generateGlobTasks;

exports.hasMagic = (patterns, options) => [].concat(patterns).some(pattern => fastGlob.isDynamicPattern(pattern, options));

exports.gitignore = gitignore;
export default exports;
export const sync = exports.sync,
      stream = exports.stream,
      hasMagic = exports.hasMagic;
const _generateGlobTasks = exports.generateGlobTasks,
      _gitignore2 = exports.gitignore;
export { _generateGlobTasks as generateGlobTasks, _gitignore2 as gitignore };